import React from "react"

import Interest from "assets/illustrations/interest.svg"

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styles from "./mission.module.css"

const Mission = () => {
  const data = useStaticQuery(graphql`
    query {
      worker: file(relativePath: { eq: "photos/mission.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <section className={styles.mission}>
      <div className="wrapper full">
        <div className={styles.callout}>
          <div className={styles.text}>
            <h3>Ajudando você a ajudar os colaboradores</h3>
            <p>
              Mais de 80% da população brasileira sofre com endividamento de
              juros altos e falta de acesso a benefícios de bem-estar
              financeiro. Resolver esse problema não é fácil, mas com tecnologia
              e parceria com as empresas é possível reverter essa situação.
            </p>
            <p>
              Nós acreditamos que educação financeira é um direito e que crédito
              justo deveria ser uma opção para todo trabalhador. Compare as
              taxas de juros:
            </p>
            <Interest className={styles.chart} />
            <p>
              <small>
                Taxa média das operações concedidas em Set 2020 de acordo com o
                Banco Central
              </small>
            </p>
          </div>
          <Img
            fluid={data.worker.childImageSharp.fluid}
            className={styles.image}
          />
        </div>
      </div>
    </section>
  )
}

export default Mission
